// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { Group } from '../../core/models/groups.model';

export enum GroupsActionTypes {
  GROUPS_LOADING = '[Groups] GROUPS_LOADING',
  GROUPS_LOAD_COMPLETE = '[Groups] GROUPS_LOAD_COMPLETE',
  GROUPS_LOAD_FAILED = '[Groups] GROUPS_LOAD_FAILED',
  GROUPS_REMOVE_BY_ID = '[Groups] GROUPS_REMOVE_BY_ID',
}

export class LoadingGroupsAction implements Action {
  readonly type = GroupsActionTypes.GROUPS_LOADING;
  constructor() {}
}

export class CompleteLoadGroupsAction implements Action {
  readonly type = GroupsActionTypes.GROUPS_LOAD_COMPLETE;
  constructor(public payload: Group[]) {}
}

export class FailLoadGroupsAction implements Action {
  readonly type = GroupsActionTypes.GROUPS_LOAD_FAILED;
  constructor() {}
}

export class RemoveGroupByIdAction implements Action {
  readonly type = GroupsActionTypes.GROUPS_REMOVE_BY_ID;
  constructor(public payload: string) {}
}

export type GroupsActions =
    LoadingGroupsAction
    | CompleteLoadGroupsAction
    | FailLoadGroupsAction
    | RemoveGroupByIdAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/groups/groups.actions.ts